import CryptoJS from "crypto-js";
import config from "@/utils/config";
export default {
  // 加密
  encrypt(word, keyStr, ivStr) {
    console.info( process.env.VUE_APP_APP_SECRET)
    keyStr = keyStr ? keyStr :  process.env.VUE_APP_APP_SECRET;
    ivStr = ivStr ? ivStr : "";
    let key = CryptoJS.enc.Utf8.parse(keyStr);
    let iv = CryptoJS.enc.Utf8.parse(ivStr);
    let srcs = CryptoJS.enc.Utf8.parse(word);

    let encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  },
  // 解密
  decrypt(word, keyStr, ivStr) {
    
    keyStr = keyStr ? keyStr :  process.env.VUE_APP_APP_SECRET;
    ivStr = ivStr ? ivStr : "";
    // console.info(keyStr,ivStr)
    var key = CryptoJS.enc.Utf8.parse(keyStr);
    // let iv = CryptoJS.enc.Utf8.parse(Array.from({length:16}).fill(0));
    var iv = CryptoJS.enc.Utf8.parse(ivStr)
    // var key = keyStr;
    // let iv = keyStr;

    var decrypt = CryptoJS.AES.decrypt(word, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return decrypt.toString(CryptoJS.enc.Utf8);
  }
};